<template>
  <div>
    <form-location-field ref="address" :field="addressField" :model="model" />
    <form-number-field
      :field="radiusField"
      :model="model"
      class="radius-input"
    />
    <div class="row">
      <div class="col-sm-4">&nbsp;</div>
      <div class="col-sm-8 text-center">{{ radiusValue }} km</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      required: true,
      type: Object,
    },
    radiusField: {
      require: true,
      type: Object,
      default: null,
    },
    addressField: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      radiusShape: null,
    }
  },

  computed: {
    radiusValue() {
      return this.model[this.radiusField.attribute]
    },
  },

  mounted() {
    this.$watch(`model.${this.radiusField.attribute}`, this.updateRadiusShape)
    this.$watch(
      `model.${this.addressField.attribute}.latlng`,
      this.updateRadiusShapeCenter,
    )

    if (this.model[this.radiusField.attribute]) {
      // small hack cause component not emit map load event
      // todo: rewrite map component
      let unwatch = this.$watch('$refs.address.googleLoaded', () => {
        this.$nextTick(() => {
          this.updateRadiusShape(this.model[this.radiusField.attribute])
          unwatch()
        })
      })
    }
  },

  methods: {
    updateRadiusShape(value) {
      this.createRadiusShape()

      if (!this.radiusShape) {
        return
      }

      if (value > 0) {
        this.radiusShape.setRadius(value * 1000)
        this.radiusShape.setMap(this.$refs.address.map)
        this.$refs.address.map.fitBounds(this.radiusShape.getBounds())
      } else {
        this.radiusShape.setMap(null)
      }
    },

    updateRadiusShapeCenter(newValue) {
      if (!newValue) {
        return
      }
      this.createRadiusShape()

      if (!this.radiusShape) {
        /* eslint-disable-next-line no-console */
        console.warn('It seems Google API not loaded')
        return
      }

      this.radiusShape.setCenter(this.createLatLng(newValue))
    },

    createRadiusShape() {
      if (!this.radiusShape && window.google) {
        this.radiusShape = new window.google.maps.Circle({
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#FF0000',
          fillOpacity: 0.35,
          center: new window.google.maps.LatLng(
            this.createLatLng(this.model[this.addressField.attribute].latlng),
          ),
          editable: false,
        })
      }
    },

    createLatLng(latlng) {
      if (!latlng) {
        return
      }
      latlng = latlng.split(',')

      return {
        lat: Number.parseFloat(latlng[0]),
        lng: Number.parseFloat(latlng[1]),
      }
    },
  },
}
</script>
<style scoped>
.radius-input {
  margin-bottom: 0;
}
</style>
